import { useState } from "react";

import {
  AlignCenter,
  AlignLeft,
  AlignRight,
  ArrowDownToLine,
  ArrowUpToLine,
  FoldVertical
} from "lucide-react";
import { connect } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import { setLayout } from "../../actions/layoutActions";
import { setObj } from "../../actions/noteActions";
import Uploader from "../../components/Uploader/uploader";
import URL from "../../config/api";
import axios from "../../config/axios";

const mockedData = {
  1: {
    id: 1,
    title: "Banner 1",
    description: "Banner 1 description",
    image: "https://utfs.io/f/2e6c15f4-46c1-4a81-8567-ddc31699a78c-mq5f7l.jpeg"
  },
  2: {
    id: 2,
    title: "Banner 2",
    description: "Banner 2 description",
    image: "https://utfs.io/f/bfa4892f-f31d-46c5-a375-b5bc122ed222-mxb5sh.jpg"
  },
  3: {
    id: 3,
    title: "Banner 3",
    description: "Banner 3 description",
    image: "https://utfs.io/f/554be2bd-192f-4c30-a3cc-57da263498c5-1xehkp.JPG"
  }
};

function DashboardBanner() {
  const [banners, setBanners] = useState(mockedData);
  const [selectedBanner, setSelectedBanner] = useState(mockedData[1]);
  const [edited, setEdited] = useState(false);

  const formatBannerPreviewTitle = title => {
    const formatedTitle =
      title.length <= 30 ? (
        title
      ) : (
        <>
          {title.substring(0, 30)}
          <u title={title}>...</u>{" "}
        </>
      );

    return (
      <span
        className="font-weight-bold w-100 text-wrap"
        style={{ maxWidth: "250px" }}
      >
        {formatedTitle}
      </span>
    );
  };

  const handleSelectBanner = id => {
    setSelectedBanner(banners[id]);
  };

  const handleSaveImage = uploads => {
    const image = URL.img + uploads[0];
    const newSelectedBanner = { ...selectedBanner };
    newSelectedBanner.image = image;

    setEdited(true);
    setSelectedBanner(newSelectedBanner);
  };

  const handleSaveBanner = event => {
    event.preventDefault();

    const newBanners = { ...banners };
    newBanners[selectedBanner.id] = selectedBanner;

    setBanners(newBanners);
  };

  return (
    <div className="d-flex flex-column m-0 p-0 h-100 w-100">
      <Card className="container p-0">
        <CardHeader>
          <h3 className="m-0 font-weight-bold font-primary">Editar banners</h3>
          <small>Veja e edite os banners do grupo</small>
        </CardHeader>
        <CardBody>
          <section className="d-flex w-100 mb-3">
            {Object.values(banners).map(banner => (
              <div
                key={banner.id}
                className={`border rounded p-2 mr-3 d-flex flex-column align-items-center ${
                  selectedBanner?.id === banner.id && "bg-primary text-white"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => handleSelectBanner(banner.id)}
              >
                <img
                  src={banner.image}
                  alt={banner.title}
                  style={{
                    width: "250px",
                    height: "150px",
                    objectFit: "cover"
                  }}
                  className="rounded-sm shadow-sm mb-1"
                />
                {formatBannerPreviewTitle(banner.title)}
              </div>
            ))}
          </section>

          <section
            className="border rounded bg-light w-100 mb-3 d-flex align-items-center justify-content-center"
            style={{ height: "420px" }}
          >
            <div
              className="position-relative rounded-lg shadow overflow-hidden"
              style={{ width: "720px", height: "350px" }}
            >
              <img
                src={selectedBanner.image}
                alt={selectedBanner.title}
                style={{ objectFit: "cover" }}
                className="rounded-sm shadow-sm mb-1 h-100 w-100"
              />
              <div
                className="position-absolute w-100 h-100"
                style={{
                  top: 0,
                  left: 0,
                  backgroundImage:
                    "linear-gradient(to top right, rgba(0, 0, 0, 0.7), transparent)"
                }}
              >
                <div className="d-flex flex-column p-3 align-items-start h-100 w-100 text-light justify-content-end">
                  <h3
                    className="w-100 m-0 text-start"
                    style={{
                      filter: "drop-shadow(0 1px 1px rgb(0 0 0 / 0.05))"
                    }}
                  >
                    {selectedBanner.title}
                  </h3>
                  <p
                    className="w-100 m-0 text-start"
                    style={{
                      filter: "drop-shadow(0 1px 1px rgb(0 0 0 / 0.05))"
                    }}
                  >
                    {selectedBanner.description}
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="d-flex flex-column w-100">
            <div className="w-100 h-100 d-flex justify-content-between">
              <Form
                className="d-flex flex-column w-100 mr-2"
                onSubmit={handleSaveBanner}
              >
                <Uploader
                  type="image"
                  maxFiles={1}
                  acceptedFileTypes={["image/*"]}
                  allowMultiple={false}
                  labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                  done={uploads => handleSaveImage(uploads)}
                />
                <FormGroup>
                  <Label for="title">Título</Label>
                  <Input
                    name="Título"
                    placeholder="Título do anúncio"
                    value={selectedBanner?.title}
                    onChange={e => {
                      const newSelectedBanner = { ...selectedBanner };
                      newSelectedBanner.title = e.target.value;
                      setEdited(true);
                      setSelectedBanner(newSelectedBanner);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="description">Descrição</Label>
                  <Input
                    name="Descrição"
                    placeholder="Descrição do anúncio"
                    type="textarea"
                    value={selectedBanner?.description}
                    onChange={e => {
                      const newSelectedBanner = { ...selectedBanner };
                      newSelectedBanner.description = e.target.value;
                      setEdited(true);
                      setSelectedBanner(newSelectedBanner);
                    }}
                  />
                </FormGroup>

                <div className="d-flex">
                  <Button
                    color={edited ? "dark" : "danger"}
                    type="button"
                    outline
                    className="w-100 mr-1"
                    onClick={() => {
                      setSelectedBanner(banners[selectedBanner.id]);
                      setEdited(false);
                    }}
                  >
                    {edited ? "Desfazer" : "Excluir"}
                  </Button>
                  <Button color="primary" type="submit" className="w-100 ml-1">
                    Salvar
                  </Button>
                </div>
              </Form>
              <div
                className="w-100 h-100 ml-2 border"
                style={{ minHeight: "240px" }}
              >
                Configuração de visualização
              </div>
            </div>
          </section>
        </CardBody>
      </Card>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBanner);
